import { Outlet, useLocation } from "react-router-dom";
import BottomTabs from "../components/BottomTabs";
import { getAIWeeklyPlanBuilderPath } from "../features/weeklyPlans/routes";
import useRouteScrollReset from "./useRouteScrollReset";
import "./mainLayout.css";

export default function MainLayout() {
  const location = useLocation();
  // Every route hosted here scrolls the document, so opening a new page starts
  // it at the top. Back/Forward and same-pathname URL changes are left alone --
  // see the hook.
  useRouteScrollReset();
  const isCycleBuilderRoute = /^\/program\/cycles\/[^/]+\/builder(?:\/|$)/.test(
    location.pathname
  );
  const isAIWeeklyPlanBuilderRoute =
    location.pathname === getAIWeeklyPlanBuilderPath();
  const isTrainFocusRoute = /^\/train\/[^/]/.test(location.pathname);
  const hideTabs =
    isTrainFocusRoute ||
    location.pathname.startsWith("/program/manual") ||
    isAIWeeklyPlanBuilderRoute ||
    isCycleBuilderRoute;

  return (
    <div className="lz-app-shell">
      <main className="lz-app-shell__main">
        <Outlet />
      </main>

      {!hideTabs && <BottomTabs />}
    </div>
  );
}
